<template>
    <div class="wrap clearfix">
        <div class="publicTitle">
            您的当前位置：{{
                $route.query.t1 +
                    ($route.query.t2
                        ? "&lt;" + $route.query.t2
                        : detailData.title
                        ? "&lt;" + detailData.title
                        : "")
            }}
        </div>
        <div class="lift-box">
            <h2 class="detail-title">
                {{ detailData.title }}
            </h2>
            <div class="titleTwo">
                <span class="time">{{
                    detailData.creaTime && detailData.creaTime.time | dateFormat
                }}</span>
                <span class="view"
                    >浏览数：{{
                        detailData.popularity ? detailData.popularity : 0
                    }}</span
                >
            </div>
            <div
                class="content weui-article"
                v-html="detailData.description"
            ></div>
        </div>
        <div class="right-box">
            <h2>相关推荐</h2>
            <div
                v-for="(item, index) in listData"
                :key="index"
                class="tui-item"
                @click="goDetails(item.id)"
            >
                <div class="img-box scale-box">
                    <img :src="item.image" :alt="item.title" />
                </div>
                <p class="title">
                    {{
                        item.title.length > 20
                            ? item.title.substring(0, 20) + "..."
                            : item.tile
                    }}
                </p>
                <p class="time">
                    {{ item.creaTime && item.creaTime.time | dateFormat }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "fczsdetail",
    data() {
        return {
            detailData: {},
            listData: []
        };
    },
    created() {
        //资讯详情
        this.getDetail(this.$route.query.id);
        this.getData();
    },
    methods: {
        getDetail(id) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformationById",
                data: {
                    id: id
                },
                success: res => {
                    if (res.code == 200) {
                        this.detailData = res.message;
                    }
                },
                error: res => {
                    console.log(res);
                }
            });
        },
        goDetails(i) {
            this.$router.push({
                name: "fczsdetail",
                query: {
                    id: i,
                    t1: "风采展示"
                }
            });
        },
        getData(page) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    current: 1,
                    navigationId: 9000
                },
                success: res => {
                    if (res.code == 200) {
                        res.message.records.length > 5
                            ? (res.message.records.length = 5)
                            : "";
                        this.listData = res.message.records;
                    }
                },
                error: res => {}
            });
        }
    },
    watch: {
        "$route.query.id": function() {
            this.getDetail(this.$route.query.id);
        }
    }
};
</script>

<style scoped="scoped" lang="scss">
.wrap {
    width: 1000px;
    margin: 0 auto;
    overflow: hidden;
    min-height: 500px;
    .publicTitle {
        margin: 5px 0;
        color: #999;
        font-size: 16px;
    }
}

.lift-box {
    width: 738px;
    padding-right: 20px;
    float: left;
    .detail-title {
        font-size: 30px;
        color: #000;
        padding: 10px 0;
    }

    .titleTwo {
        color: #666;
        padding-bottom: 40px;
        .view {
            padding-left: 30px;
        }
    }

    .content {
        min-height: 500px;
    }
}
.right-box {
    width: 242px;
    float: right;
    h2 {
        width: 100%;
        text-align: center;
        color: #6ac0e8;
        font-size: 18px;
    }
    .tui-item {
        width: 240px;
        margin-top: 15px;
        .img-box {
            width: 240px;
            height: 162px;
            border: 1px solid #ddd;
            overflow: hidden;
            img {
                width: 100%;
                min-height: 100%;
            }
        }
        .title {
            line-height: 22px;
            padding: 5px 0;
            font-size: 16px;
        }
        .time {
            color: #999;
            font-size: 14px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/public/fczsdetail.vue